import { render, staticRenderFns } from "./ProviderModelsList.vue?vue&type=template&id=49d39b78"
import script from "./ProviderModelsList.vue?vue&type=script&lang=js"
export * from "./ProviderModelsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports